import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { sortByProperty } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import Countinue from './countinue/countinue';
import RosterSetup from './roster-setup/roster-setup';
import SsoTypeSetup from './sso-type-setup/sso-type-setup';

@Component({
    name: 'tenant-configurations',
    components: {
        'sso-type-setup': SsoTypeSetup,
        'roster-setup': RosterSetup,
        'countinue': Countinue,
    },
})

export default class TenantConfigurations extends Vue {

    private activeComponent: any = 'sso-type-setup';

    private userData: any = {};

    private tenantList: any = [];

    private textMessgaes: any = {
        main: 'Your tenancy is created. However you need to update few mandatory setting to make the your tenant active.',
        subText: 'Please follow the wizard',
    };

    private isclickedToProceed: boolean = false;
    // ----------------------------------------------------------------------------
    // Actions
    private onSwitchComponent(key: string, userData: any) {
        if (key === 'home') {
            this.isclickedToProceed = false;
        } else {
            this.userData = userData;
            this.activeComponent = key;
        }
    }

}
